<template>
  <v-row density="compact">
    <p>
      Bollinger bands can identify overbought or oversold conditions. Closing prices above the upper
      band could indicate overbought conditions. Closing prices below the lower band could indicate
      oversold conditions.
    </p>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.upper_lower"
        :items="['upper', 'lower']"
        label="upper or lower band"
        hint="upper or lower band"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('upper_lower', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.ma_days"
        :items="[
          2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
          26, 27, 28, 29, 30
        ]"
        label="Moving Avg Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('ma_days', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.stddev"
        density="compact"
        hide-details
        variant="outlined"
        label="# Standard Deviations (max 5)"
        @update:model-value="updateConfig('stddev', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-select
        :model-value="rule.config.above_below"
        :items="['above', 'below']"
        label="Current Price Above or Below BBand"
        hint="Current Price Above or Below BBand"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col v-if="1 == 2" cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.consecutive_days"
        density="compact"
        hide-details
        variant="outlined"
        label="Consecutive days price has been above or below"
        @update:model-value="updateConfig('consecutive_days', $event)"
      />
    </v-col>

    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.percent"
        density="compact"
        hide-details
        variant="outlined"
        label="% Closing price above or below BBand"
        hint="Closing Price % Above or Below BBand"
        @update:model-value="updateConfig('percent', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      editedTa: {
        enabled: true,
        above_below: 'below',
        upper_lower: 'lower',
        rule_type: 'bb',
        consecutive_days: 5,
        percent: 3,
        long_short: 'long',
        ma_days: 20,
        stddev: 2
      },
      defaultTa: {
        enabled: true,
        above_below: 'below',
        upper_lower: 'lower',
        rule_type: 'bb',
        consecutive_days: 5,
        percent: 3,
        long_short: 'long',
        ma_days: 20,
        stddev: 2
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'bb') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
